import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait for the page to render, then scroll to the element
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          const headerOffset = 128; // account for fixed header/navigation + spacing
          const elementRect = element.getBoundingClientRect();
          const scrollTop = window.scrollY + elementRect.top - headerOffset;
          window.scrollTo({ top: Math.max(scrollTop, 0), behavior: 'smooth' });
        }
      }, 0);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
